import { spawn } from 'typed-redux-saga/macro';
import budgetingAnalyticsSaga from 'features/analytics/sagas';
import creditScoreSaga from 'features/credit-score/sagas';
import feedSaga from 'features/feed/sagas';
import funnelEventsSaga from 'features/funnel-events/sagas';
import investSaga from 'features/invest/sagas';
// import { promotionsSaga } from 'features/promotions/sagas/promotionsSaga';
import rentReportingSaga from 'features/rent-reporting/sagas';
import spaceSaga from 'features/spaces/sagas';
import subscriptionsSaga from 'features/subscriptions/sagas';
import appStateSaga from 'sagas/AppStateSaga';
import netInfoSaga from 'sagas/NetInfoSaga';
import autosaveSagas from 'features/pots/sagas/autosaveSagas';
import potsSagas from 'features/pots/sagas/potsSagas';
import wealthSaga from 'features/wealth/sagas';
import overviewSaga from 'features/feed/sagas/overview';
import refreshSaga from './RefreshSaga';
import onAppActiveSaga from './onAppActiveSaga';
import logoutSaga from './logoutSaga';
import accountsSaga from './accountsSaga';
import billingSagas from '../features/premium/sagas/billing';
function* startupSaga() {
    yield* spawn(logoutSaga);
    yield* spawn(investSaga);
    yield* spawn(spaceSaga);
    yield* spawn(overviewSaga);
    yield* spawn(netInfoSaga);
    yield* spawn(appStateSaga);
    yield* spawn(budgetingAnalyticsSaga);
    yield* spawn(refreshSaga);
    yield* spawn(onAppActiveSaga);
    yield* spawn(subscriptionsSaga);
    yield* spawn(feedSaga);
    yield* spawn(potsSagas);
    yield* spawn(autosaveSagas);
    yield* spawn(wealthSaga);
    yield* spawn(billingSagas);
    yield* spawn(creditScoreSaga);
    // yield* spawn(promotionsSaga);
    yield* spawn(rentReportingSaga);
    yield* spawn(accountsSaga);
    yield* spawn(funnelEventsSaga);
}
export default startupSaga;
